import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  Category,
  CategoryWithRecipes,
  Recipe,
} from 'src/Model/Product-Interfaces';
import { RequestService } from './request.service';
import { brandFlavor } from 'src/app/brand/brand-context';
interface CategoriesAndRecipes {
  Categories: Category[];
  CategoriesAndRecipes: CategoryWithRecipes[];
  Info: {
    Status: number;
  };
}
@Injectable({
  providedIn: 'root',
})
export class RecipeService {
  private brandFlavour: string;
  private dataSubject = new BehaviorSubject<CategoriesAndRecipes>(null);
  data$: Observable<CategoriesAndRecipes> = this.dataSubject.asObservable();

  constructor(private _requestService: RequestService) {
    this.brandFlavour = brandFlavor();
    this.initateRecipes();
  }

  /**
   * What a recipe can actually be ordered as: its own flags AND its
   * category's. A dish flagged ForEatIn inside a category that is not
   * offered for eat-in is not available for eat-in — the menu hides the
   * whole category, but a cart line added under another order type (or from
   * search / favourites / a reorder) only carried the recipe's flags, so the
   * checkout let it through. Cart lines and the checkout filter use this.
   * Returns null while the menu hasn't loaded or the recipe isn't on it.
   */
  availabilityOf(
    recipeId: number,
    categoryId?: number
  ): OrderTypeAvailability | null {
    const data = this.dataSubject.getValue();
    if (!data) return null;

    const menu = data.CategoriesAndRecipes || [];
    let category: CategoryWithRecipes | undefined = categoryId
      ? menu.find((c) => c.CategoryId === categoryId)
      : undefined;
    let recipe: Recipe | undefined = category?.Recipes?.find(
      (rec) => rec.RecipeId === recipeId
    );
    if (!recipe) {
      category = menu.find((c) =>
        (c.Recipes || []).some((rec) => rec.RecipeId === recipeId)
      );
      recipe = category?.Recipes?.find((rec) => rec.RecipeId === recipeId);
    }
    if (!recipe || !category) return null;

    return {
      ForDelivery: !!recipe.ForDelivery && !!category.ForDelivery,
      ForCollection: !!recipe.ForCollection && !!category.ForCollection,
      ForEatIn: !!recipe.ForEatIn && !!category.ForEatIn,
      ForDineIn: !!recipe.ForDineIn && !!category.ForDineIn,
    };
  }

  refreshRecipes() {
    this.dataSubject.next(null);
    this.initateRecipes();
  }

  private initateRecipes() {
    const data = this.dataSubject.getValue();
    if (!data) {
      this.getCategories();
    }
  }
  
  private getCategories() {
    this._requestService
      .getRequest('api/Recipe/GetOnlineRecipesData/' + this.brandFlavour)
      .subscribe((res: CategoriesAndRecipes) => {
        if (res.Info.Status == 200) {
          this.dataSubject.next(res);
        }
      });
  }
}

export interface OrderTypeAvailability {
  ForDelivery: boolean;
  ForCollection: boolean;
  ForEatIn: boolean;
  ForDineIn: boolean;
}
